// extracted by mini-css-extract-plugin
module.exports = {"total-items":"TotalItems_total-items__ndWsP"};